// 2026-10-18：维语日期使用已安装Day.js维语数据，表单及组件完整文案使用同一词典。
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import 'dayjs/locale/ug-cn'
import { translateMessages } from './display'
const ugLocale = translateMessages(zhCN, 'ug')
ugLocale.locale = 'ug'
for (const component of ['DatePicker', 'Calendar']) {
  if (ugLocale[component]?.lang) ugLocale[component].lang.locale = 'ug-cn'
}
export default ugLocale
